import React, { useState } from 'react';
import WaSendModal from './WaSendModal';

const WEDDING_DATE = new Date('2023-11-11');

function getMarriageAge() {
  const now = new Date();
  const diff = now - WEDDING_DATE;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  return { days, years, months };
}

const DEFAULT_MEMORIES = [
  { id: 1, emoji: '💍', caption: 'Hari paling bahagia — 11 November 2023', date: '11-11-2023', note: 'Hari pernikahan kita. Sistem go live.' },
  { id: 2, emoji: '🏠', caption: 'Rumah kita yang pertama', date: 'Desember 2023', note: 'Kita mulai membangun sarang kita.' },
  { id: 3, emoji: '🌅', caption: 'Liburan pertama berdua', date: '2024', note: 'Sunrise paling indah, dilihat bersamamu.' },
  { id: 4, emoji: '🎂', caption: 'Ulang tahun Nof — 5 Mei 2026', date: '05-05-2026', note: 'Hari ini. Hari kamu. 💖' },
];

const GRADIENT_OPTIONS = [
  'linear-gradient(135deg,#be123c,#9f1239)',
  'linear-gradient(135deg,#1d4ed8,#1e40af)',
  'linear-gradient(135deg,#15803d,#166534)',
  'linear-gradient(135deg,#7c3aed,#6d28d9)',
  'linear-gradient(135deg,#b45309,#92400e)',
  'linear-gradient(135deg,#0e7490,#155e75)',
];

const EMOJI_OPTIONS = ['💍','🌹','🎂','🏠','✈️','🌅','🎉','💖','🥂','📸','🌊','🎵'];

// ── Modal Form ──
const MemoryModal = ({ memory, onSave, onClose }) => {
  const [form, setForm] = useState(memory || { emoji: '💖', caption: '', date: '', note: '', gradient: GRADIENT_OPTIONS[0] });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        <div style={S.modalHead}>
          <h3 style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>{memory ? 'Edit Kenangan' : 'Tambah Kenangan'}</h3>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* Emoji picker */}
        <label style={S.label}>Ikon</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {EMOJI_OPTIONS.map(e => (
            <button key={e} onClick={() => set('emoji', e)}
              style={{ fontSize: 24, padding: 6, borderRadius: 8, border: form.emoji === e ? '2px solid #e11d48' : '2px solid transparent', background: 'rgba(255,255,255,0.05)', cursor: 'pointer' }}>
              {e}
            </button>
          ))}
        </div>

        {/* Gradient */}
        <label style={S.label}>Warna Kartu</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          {GRADIENT_OPTIONS.map(g => (
            <button key={g} onClick={() => set('gradient', g)}
              style={{ width: 32, height: 32, borderRadius: 8, background: g, border: form.gradient === g ? '2px solid #fff' : '2px solid transparent', cursor: 'pointer' }} />
          ))}
        </div>

        <label style={S.label}>Judul *</label>
        <input style={S.input} value={form.caption} onChange={e => set('caption', e.target.value)} placeholder="Ceritakan momennya..." />

        <label style={S.label}>Tanggal</label>
        <input style={S.input} value={form.date} onChange={e => set('date', e.target.value)} placeholder="cth: 11-11-2023" />

        <label style={S.label}>Catatan</label>
        <textarea style={{ ...S.input, height: 80, resize: 'vertical' }} value={form.note} onChange={e => set('note', e.target.value)} placeholder="Detail singkat..." />

        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button style={S.btnSave} onClick={() => { if (form.caption.trim()) onSave(form); }}>
            {memory ? '💾 Simpan' : '➕ Tambah'}
          </button>
          <button style={S.btnCancel} onClick={onClose}>Batal</button>
        </div>
      </div>
    </div>
  );
};

// ── Memory Card ──
const MemCard = ({ mem, onEdit, onDelete, onSendWa }) => {
  const [menu, setMenu] = useState(false);
  return (
    <div style={{ ...S.card, background: mem.src ? undefined : mem.gradient || GRADIENT_OPTIONS[0], position: 'relative' }}>
      {mem.src
        ? <img src={mem.src} alt={mem.caption} style={{ width: '100%', aspectRatio: '1', objectFit: 'cover' }} />
        : <div style={S.cardInner}><span style={{ fontSize: 48 }}>{mem.emoji || '💖'}</span><span style={S.cardDate}>{mem.date}</span></div>
      }
      <div style={S.cardCaption}>
        <p style={{ color: '#fff', fontSize: 13, fontWeight: 600, margin: 0 }}>{mem.caption}</p>
        {mem.note && <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginTop: 2 }}>{mem.note}</p>}
      </div>

      {/* Menu */}
      <div style={{ position: 'absolute', top: 8, right: 8 }}>
        <button style={S.menuBtn} onClick={() => setMenu(m => !m)}>⋯</button>
        {menu && (
          <div style={S.menuDropdown} onClick={() => setMenu(false)}>
            <button style={S.menuItem} onClick={() => onEdit(mem)}>✏️ Edit</button>
            {mem.src && <button style={S.menuItem} onClick={() => onSendWa(mem.src)}>📲 Kirim WA</button>}
            <button style={{ ...S.menuItem, color: '#f87171' }} onClick={() => onDelete(mem.id)}>🗑️ Hapus</button>
          </div>
        )}
      </div>
    </div>
  );
};

// ── Main Component ──
export default function RecapGallery({ capturedPhotos }) {
  const age = getMarriageAge();
  const [memories, setMemories] = useState(DEFAULT_MEMORIES);
  const [modalMode, setModalMode] = useState(null); // null | 'add' | memory object
  const [waTarget, setWaTarget] = useState(null);

  const handleSave = (form) => {
    if (form.id) {
      setMemories(prev => prev.map(m => m.id === form.id ? { ...form } : m));
    } else {
      setMemories(prev => [...prev, { ...form, id: Date.now() }]);
    }
    setModalMode(null);
  };

  const handleDelete = (id) => {
    if (window.confirm('Hapus kenangan ini?')) setMemories(prev => prev.filter(m => m.id !== id));
  };

  const handleFileAdd = (e) => {
    Array.from(e.target.files).forEach(file => {
      const reader = new FileReader();
      reader.onload = ev => setMemories(prev => [...prev, {
        id: Date.now() + Math.random(),
        src: ev.target.result,
        caption: file.name.replace(/\.[^.]+$/, ''),
        date: new Date().toLocaleDateString('id-ID'),
        note: '',
        emoji: '📸',
        gradient: GRADIENT_OPTIONS[0],
      }]);
      reader.readAsDataURL(file);
    });
  };

  const boothPhotos = capturedPhotos.map((src, i) => ({
    id: `booth-${i}`,
    src,
    caption: `Photobooth #${i + 1}`,
    date: new Date().toLocaleDateString('id-ID'),
    note: 'Foto dari photobooth HBD Nof 💖',
    emoji: '📸',
    gradient: GRADIENT_OPTIONS[0],
  }));

  const all = [...boothPhotos, ...memories];

  return (
    <div>
      {/* Marriage Counter Banner */}
      <div style={S.banner}>
        <div style={S.bannerItem}>
          <span style={S.bannerNum}>{age.years}</span>
          <span style={S.bannerLabel}>Tahun</span>
        </div>
        <div style={S.bannerDivider} />
        <div style={S.bannerItem}>
          <span style={S.bannerNum}>{age.months}</span>
          <span style={S.bannerLabel}>Bulan</span>
        </div>
        <div style={S.bannerDivider} />
        <div style={S.bannerItem}>
          <span style={S.bannerNum}>{age.days}</span>
          <span style={S.bannerLabel}>Hari bersama</span>
        </div>
        <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
          <p style={{ color: '#f9a8d4', fontWeight: 700, fontSize: 14, margin: 0 }}>Nof & Suami</p>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11, margin: 0 }}>Sejak 11 November 2023 💍</p>
        </div>
      </div>

      {/* Header Row */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <h2 style={{ color: '#fff', fontWeight: 700, fontSize: 20, margin: 0 }}>Kenangan Kita</h2>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 12, margin: '4px 0 0' }}>{all.length} momen tersimpan</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <label style={S.btnOutline} title="Upload foto">
            📁 Upload
            <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={handleFileAdd} />
          </label>
          <button style={S.btnPrimary} onClick={() => setModalMode('add')}>+ Tambah</button>
        </div>
      </div>

      {/* Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
        {all.map(mem => (
          <MemCard key={mem.id} mem={mem} onEdit={m => setModalMode(m)} onDelete={handleDelete} onSendWa={setWaTarget} />
        ))}
      </div>

      {/* Modals */}
      {modalMode && (
        <MemoryModal
          memory={modalMode === 'add' ? null : modalMode}
          onSave={handleSave}
          onClose={() => setModalMode(null)}
        />
      )}
      {waTarget && <WaSendModal isOpen onClose={() => setWaTarget(null)} imageDataUrl={waTarget} />}
    </div>
  );
}

// ── Styles ──
const S = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modal: { background: '#140020', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: 24, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' },
  modalHead: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 },
  closeBtn: { background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: 18, cursor: 'pointer' },
  label: { display: 'block', color: 'rgba(255,255,255,0.5)', fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 },
  input: { width: '100%', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 14px', color: '#fff', fontSize: 14, outline: 'none', marginBottom: 16, fontFamily: 'inherit', boxSizing: 'border-box' },
  btnSave: { flex: 1, padding: '12px 20px', background: '#e11d48', border: 'none', borderRadius: 10, color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  btnCancel: { padding: '12px 20px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, color: 'rgba(255,255,255,0.6)', fontSize: 14, cursor: 'pointer' },
  card: { borderRadius: 16, overflow: 'hidden', cursor: 'pointer' },
  cardInner: { aspectRatio: '1', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8 },
  cardDate: { color: 'rgba(255,255,255,0.6)', fontSize: 11, fontFamily: 'JetBrains Mono, monospace' },
  cardCaption: { padding: '10px 12px', background: 'rgba(0,0,0,0.35)' },
  menuBtn: { background: 'rgba(0,0,0,0.5)', border: 'none', color: '#fff', borderRadius: 6, width: 28, height: 28, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  menuDropdown: { position: 'absolute', top: 36, right: 0, background: '#1a0030', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, overflow: 'hidden', zIndex: 50, minWidth: 140 },
  menuItem: { display: 'block', width: '100%', padding: '10px 16px', background: 'transparent', border: 'none', color: '#fff', fontSize: 13, textAlign: 'left', cursor: 'pointer' },
  banner: { display: 'flex', alignItems: 'center', gap: 20, background: 'rgba(225,29,72,0.1)', border: '1px solid rgba(225,29,72,0.2)', borderRadius: 16, padding: '16px 20px', marginBottom: 20 },
  bannerItem: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  bannerNum: { color: '#fff', fontWeight: 900, fontSize: 28, lineHeight: 1 },
  bannerLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: 2 },
  bannerDivider: { width: 1, height: 40, background: 'rgba(255,255,255,0.1)' },
  btnPrimary: { padding: '8px 16px', background: '#e11d48', border: 'none', borderRadius: 10, color: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer' },
  btnOutline: { padding: '8px 16px', background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10, color: 'rgba(255,255,255,0.6)', fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 },
};
